import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getScholarshipCombinations,
  getScholarshipCourses,
  getScholarshipSchedule,
  getScholarshipAppealSettings,
} from "../../../../store/scholarship/actions";

import { getQualificationLevels } from "../../../../store/posts/actions";
import ScholarshipSpecializations from "../components/ScholarshipSpecializations";
import ScholarshipDepartments from "../components/ScholarshipDepartments";
import ScholarshipScheduleDialog from "../components/ScholarshipScheduleDialog";
import ScholarshipAppealSettingsDialog from "../components/ScholarshipAppealSettingsDialog";
import moment from "moment";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

function calculateTimeLeft(scholarshipSchedule) {
  const year = new Date().getFullYear();
  const deadLine = !!scholarshipSchedule
    ? new Date(moment(scholarshipSchedule.endOn).format("yyyy-MM-DD"))
    : new Date(moment().format("yyyy-MM-DD"));

  deadLine.setDate(deadLine.getDate() + 1);
  deadLine.setHours(deadLine.getHours() - 1);

  const toDay = new Date();

  const difference = +deadLine - +toDay;

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
}

function isAppealWindowOpen(scholarshipAppealSettings) {
  return (
    !!scholarshipAppealSettings &&
    !!scholarshipAppealSettings.enabled &&
    !!scholarshipAppealSettings.openedOn &&
    moment().diff(moment(scholarshipAppealSettings.openedOn), "days") <=
      scholarshipAppealSettings.windowDays
  );
}

function calculateAppealTimeLeft(scholarshipAppealSettings) {
  if (!isAppealWindowOpen(scholarshipAppealSettings)) return {};

  const deadLine = moment(scholarshipAppealSettings.openedOn)
    .add(scholarshipAppealSettings.windowDays, "days")
    .toDate();

  const difference = +deadLine - +new Date();

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
}

const ScholarshipSettings = (props) => {
  // useEffect(() => {
  //   document.title = "TMIS | System Users";
  // }, []);

  const { hasPermissions } = useRequiredAuth();

  const {
    user,
    loading,
    getScholarshipCombinations,
    getScholarshipCourses,
    getQualificationLevels,
    scholarshipSchedule,
    getScholarshipSchedule,
    scholarshipAppealSettings,
    getScholarshipAppealSettings,
  } = props;

  useEffect(() => {
    getScholarshipCombinations();
    getScholarshipCourses();
    getQualificationLevels();
    getScholarshipSchedule();
    getScholarshipAppealSettings();
  }, []);

  const [showScheduleDialog, setShowScheduleDialog] = useState(false);
  const [showAppealSettingsDialog, setShowAppealSettingsDialog] =
    useState(false);

  const [timeLeft, setTimeLeft] = useState(
    calculateTimeLeft(scholarshipSchedule)
  );
  const [appealTimeLeft, setAppealTimeLeft] = useState(
    calculateAppealTimeLeft(scholarshipAppealSettings)
  );

  useEffect(() => {
    const id = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(scholarshipSchedule));
      setAppealTimeLeft(calculateAppealTimeLeft(scholarshipAppealSettings));
    }, 1000);

    return () => {
      clearTimeout(id);
    };
  });

  const timerComponents = Object.keys(timeLeft).map((interval, index) => {
    if (!timeLeft[interval]) {
      <span key={index}>00</span>;
    }

    return (
      <span key={index}>
        {timeLeft[interval].toString().padStart(2, "0")}
        {index + 1 < Object.keys(timeLeft).length && <>:</>}
      </span>
    );
  });

  const appealTimerComponents = Object.keys(appealTimeLeft).map(
    (interval, index) => {
      if (!appealTimeLeft[interval]) {
        <span key={index}>00</span>;
      }

      return (
        <span key={index}>
          {appealTimeLeft[interval].toString().padStart(2, "0")}
          {index + 1 < Object.keys(appealTimeLeft).length && <>:</>}
        </span>
      );
    }
  );

  return (
    <div>
      <div
        style={{
          backgroundColor: "#f3f4f6",
          borderRadius: "0.5rem",
          boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
          MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
          height: "65vh",
          overflowY: "auto",
        }}
        className="px-3"
      >
        <AppBar position="static" elevation={0}>
          <Toolbar
            style={{
              minHeight: "0px",
              // borderBottom: "3px solid #e9ecef",
            }}
            className=" my-0 py-1 bg-white mx-n3"
          >
            <span className="text-uppercase text-primary">Scholarships</span>

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: { xs: "flex", md: "flex" } }}>
              {!!scholarshipSchedule &&
                moment(scholarshipSchedule.startOn).format("yyyy-MM-DD") <=
                  moment().format("yyyy-MM-DD") &&
                moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") >=
                  moment().format("yyyy-MM-DD") && (
                  <span
                    className="font-weight-bold ml-2"
                    style={{ color: "#ed6c02" }}
                  >
                    {timerComponents.length ? (
                      timerComponents
                    ) : (
                      <span
                        className={`badge badge-danger ml-2`}
                        style={{ cursor: "default" }}
                      >
                        <i className="fas fa-lock mr-1"></i> CLOSED
                      </span>
                    )}
                  </span>
                )}

              {!(
                !!scholarshipSchedule &&
                moment(scholarshipSchedule.startOn).format("yyyy-MM-DD") <=
                  moment().format("yyyy-MM-DD") &&
                moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") >=
                  moment().format("yyyy-MM-DD")
              ) && (
                <span
                  className={`badge badge-danger ml-2`}
                  style={{ cursor: "default" }}
                >
                  <span>
                    {!scholarshipSchedule ||
                    (!!scholarshipSchedule &&
                      moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") <
                        moment().format("yyyy-MM-DD")) ? (
                      <i className="fas fa-lock mr-1"></i>
                    ) : (
                      <i className="fas fa-clock mr-1"></i>
                    )}

                    {!scholarshipSchedule ||
                    (!!scholarshipSchedule &&
                      moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") <
                        moment().format("yyyy-MM-DD"))
                      ? "CLOSED"
                      : `Will start on ${moment(
                          scholarshipSchedule.startOn
                        ).format("ll")}`}
                  </span>
                </span>
              )}
            </Box>
            <Box sx={{ display: { xs: "flex", md: "flex" } }}>
              {isAppealWindowOpen(scholarshipAppealSettings) ? (
                <span
                  className="font-weight-bold ml-2"
                  style={{ color: "#ed6c02" }}
                >
                  <i className="fas fa-comment-dots mr-1"></i> Appeals open{" "}
                  {appealTimerComponents}
                </span>
              ) : (
                <span
                  className={`badge badge-danger ml-2`}
                  style={{ cursor: "default" }}
                >
                  <i className="fas fa-lock mr-1"></i> Appeals closed
                </span>
              )}
            </Box>
            {hasPermissions(["SCHOLARSHIPS_SCHEDULE"]) && (
              <Button
                className="ml-1"
                disabled={loading}
                onClick={() => {
                  setShowScheduleDialog(true);
                }}
                variant="contained"
                size="small"
                disableElevation
                color="primary"
              >
                Schedule
              </Button>
            )}
            {hasPermissions(["GLOBAL_SETTINGS_SCHOLARSHIPS"]) && (
              <Button
                className="ml-1"
                disabled={loading}
                onClick={() => {
                  setShowAppealSettingsDialog(true);
                }}
                variant="contained"
                size="small"
                disableElevation
                color="primary"
              >
                Appeal Settings
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <div className="row mt-1">
          <div className="col-12 col-lg-6">
            <ScholarshipDepartments />
          </div>
          <div className="col-12 col-lg-6">
            <ScholarshipSpecializations />
          </div>
        </div>
        {showScheduleDialog && (
          <ScholarshipScheduleDialog
            scholarshipSchedule={scholarshipSchedule}
            showDialog={showScheduleDialog}
            setShowDialog={setShowScheduleDialog}
          />
        )}
        {showAppealSettingsDialog && (
          <ScholarshipAppealSettingsDialog
            scholarshipAppealSettings={scholarshipAppealSettings}
            showDialog={showAppealSettingsDialog}
            setShowDialog={setShowAppealSettingsDialog}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  user,
  loading,
  scholarshipSchedule,
  scholarshipAppealSettings,
}) => {
  return { user, loading, scholarshipSchedule, scholarshipAppealSettings };
};

export default connect(mapStateToProps, {
  getScholarshipCombinations,
  getScholarshipCourses,
  getQualificationLevels,
  getScholarshipSchedule,
  getScholarshipAppealSettings,
})(ScholarshipSettings);
